import React from "react";

import { isMeetinOpenUtil } from "../utils/meeting-utils";
import { USER_ROLES } from "./UserProvider";
import SideMeetingDetails from "./SideMeetingDetails";
import SideTabs from "./SideTabs";
import CompanyHeader from "./CompanyHeader";
import ReceptionWelcome from "./ReceptionWelcome";
import NoReceptionNoMeetingWelcome from "./NoReceptionNoMeetingWelcome";

const ReceptionClosed = ({
  sidebarCollapsed,
  meetingId,
  meetingDetails,
  ismeetingOpened,
  companyProfile,
  userIsInviteeToMeeting,
  role,
  hosts,
  onJoinMeeting = () => {},
  onNotify = () => {},
}) => {
  return (
    <div className="row h-100">
      <div className="col-sm-12 col-md-8 col-xl-9">
        <div className="header text-center text-uppercase my-3">
          <CompanyHeader profile={companyProfile} />
        </div>

        {(!userIsInviteeToMeeting || !meetingId) && (
          <NoReceptionNoMeetingWelcome companyProfile={companyProfile} />
        )}

        {userIsInviteeToMeeting && role === USER_ROLES.DELEGATE && meetingId && (
          <>
            <ReceptionWelcome
              meetingDetails={meetingDetails}
              meetingOpen={ismeetingOpened}
              companyProfile={companyProfile}
            />

            <div className="text-center">
              {meetingDetails && (
                <span>
                  <button
                    className={`btn join-meeting-button ${
                      isMeetinOpenUtil(meetingDetails, ismeetingOpened)
                        ? "btn-primary"
                        : "btn-outline-primary"
                    }`}
                    type="button"
                    onClick={onJoinMeeting}
                    disabled={
                      !isMeetinOpenUtil(meetingDetails, ismeetingOpened)
                    }
                  >
                    JOIN MEETING
                  </button>
                </span>
              )}

              {meetingDetails &&
                !isMeetinOpenUtil(meetingDetails, ismeetingOpened) && (
                  <span className="notify-button">
                    <button
                      className="btn btn-primary join-meeting-button"
                      type="button"
                      onClick={onNotify}
                    >
                      NOTIFY
                    </button>
                  </span>
                )}
            </div>
          </>
        )}
      </div>

      {/* Sidebar */}
      <div className="col-sm-12 col-md-4 col-xl-3 px-0">
        {userIsInviteeToMeeting && meetingDetails ? (
          <SideMeetingDetails meetingDetails={meetingDetails} />
        ) : role === USER_ROLES.DELEGATE && !meetingId ? (
          <SideTabs
            sidebarCollapsed={sidebarCollapsed}
            attendees={hosts}
            ShowChatTab={false}
            attendeesTabLabel="TEAM DELEGATES"
          />
        ) : null}
      </div>
    </div>
  );
};

export default ReceptionClosed;
